import type { TicketBlueprint } from '../../../generated/api.graphql';
import { take } from '../../../util';

type GQLItem = Pick<TicketBlueprint, 'id' | 'name' | 'sellStart' | 'sellEnd'>;

/**
 * A sellable ticket type — the *blueprint* an event offers, not a ticket somebody bought.
 * This is the read behind the discount and presale ticket pickers: the operator picks
 * blueprints, and the association decides which tickets a discount or presale applies to.
 *
 * Deliberately narrow. Nothing here describes price, inventory or an order line, and it
 * should not grow to — the order surfaces have their own types.
 */
export type EventTicketType = {
  id: number;
  name: string;
  sellStart?: string;
  sellEnd?: string;
};

/**
 * `take` for the non-nullable fields, `?? undefined` for the rest: `take` skips a key only
 * when its value is `undefined`, and the backend answers an absent nullable field with
 * `null` — so a take-only mapper would put a `null` in a field this type promises as
 * `string | undefined`, and every consumer would have to re-check. Same shape as
 * `App/SeatingChart/SeatingChart.ts`.
 */
export const fromGql = (item: GQLItem): EventTicketType => ({
  ...take<EventTicketType>(item, 'id', 'name'),
  sellStart: item.sellStart ?? undefined,
  sellEnd: item.sellEnd ?? undefined,
});
